// src/components/Signup.js (Updated for CSS)
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

const GOOGLE_ICON_URL = 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name || !email || !password || !confirmPassword) {
      setError('All fields are required.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (!agreedToTerms) {
      setError('You must agree to the Terms and Privacy Policy.');
      return;
    }

    try {
      const res = await axios.post('http://localhost:5000/api/users/register', { name, email, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Signup failed. Please try again.');
    }
  };

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible);

  const handleGoogleSignup = () => alert('Simulating Google Signup!');

  return (
    <div className="auth-page section-padding">
      <div className="auth-form-container main-content">
        <Link to="/login" className="auth-back-arrow">&larr;</Link>

        <h1 className="auth-heading">Create Account</h1>
        <p className="auth-subtext">Join the community to personalize your experience.</p>

        {/* Social Signup */}
        <div className="social-login-section">
          <button type="button" onClick={handleGoogleSignup} className="btn-secondary google-login-btn">
            <img src={GOOGLE_ICON_URL} alt="Google Symbol" className="google-icon" />
            Sign up with Google
          </button>
        </div>

        <div className="divider"><span>or Sign Up with Email</span></div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <p className="auth-error-message">{error}</p>}

          <div className="form-group">
            <label htmlFor="name" className="sr-only">Full Name</label>
            <input type="text" id="name" placeholder="Full Name *" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="sr-only">Email</label>
            <input type="email" id="email" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>

          <div className="form-group password-wrapper">
            <label htmlFor="password" className="sr-only">Password</label>
            <input type={passwordVisible ? 'text' : 'password'} id="password" placeholder="Password *" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <span className="password-toggle-icon" onClick={togglePasswordVisibility}>
              <i className={passwordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
            </span>
          </div>

          <div className="form-group password-wrapper">
            <label htmlFor="confirmPassword" className="sr-only">Confirm Password</label>
            <input type={confirmPasswordVisible ? 'text' : 'password'} id="confirmPassword" placeholder="Confirm Password *" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
            <span className="password-toggle-icon" onClick={toggleConfirmPasswordVisibility}>
              <i className={confirmPasswordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
            </span>
          </div>

          <div className="form-group terms-checkbox-group">
            <input type="checkbox" id="terms" checked={agreedToTerms} onChange={(e) => setAgreedToTerms(e.target.checked)} required />
            <label htmlFor="terms" className="terms-label">
              I agree to the <Link to="/terms" className="auth-link">Terms</Link> and <Link to="/privacy" className="auth-link">Privacy Policy</Link>
            </label>
          </div>

          <button type="submit" className="btn-primary auth-submit-btn">Sign Up</button>
        </form>

        <div className="auth-footer center-text">
          Already have an account? <Link to="/login" className="auth-link">Login &rarr;</Link>
        </div>
      </div>
    </div>
  );
};

export default Signup;
